import ProjectCommons from "../project-commons";
import Header from "../header";
import {fichaFn} from "../ficha-fn";

export class FichaPage {
    constructor() {
        console.log('init FichaPage');

        if(!window) return;

        new ProjectCommons();
        this.header = new Header();

        this.initNonAjax().then();
    }

    async initNonAjax() {
        await fichaFn.fichaEssentials(
            window.projectSettingsOptions.storiesEnabled,
        );

        if (window.history && window.history.pushState)
            window.addEventListener('popstate', () => window.location.reload(), {once: true});

        fichaFn.scrollEventFicha(window, () => {
            fichaFn.toggleDescriptionCollapse();
            fichaFn.getReportAdDesk().then();
            fichaFn.getRelatedFichas().then();
            fichaFn.getMapSection().then();
        });
    }

}
window.fichaPage = new FichaPage();